




























import { Vue, Component } from "vue-property-decorator";
@Component
export default class DomainNameWidgets extends Vue {
  // eslint-disable-next-line
  public snippet = `<script src="https://widgets.upmind.app/dac/upm-dac.min.js"><\/script>
<upm-dac
  order-config-url="{orderConfigUrl}"
  currency-code="{currency}"
></upm-dac>`;
}
